import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "@/store"
import MainNavigation from "@/views/front/MainNavigation.vue";

Vue.use(VueRouter)

const routes = [
  // 根路径重定向到前台首页
  {
    path: '/',
    redirect: '/front/home'
  },

  // 独立数据中台页面
  {
    path: '/DataPlatform',
    name: 'DataPlatform',
    component: () => import('../views/DataPlatform.vue'),
    meta: { noNav: true }
  },

  // 前台用户界面
  {
    path: '/front',
    name: 'Front',
    component: MainNavigation,
    children: [
      { path: 'home', name: 'home', component: () => import('../views/front/Home.vue')},
      { path: 'DataOverview', name: 'DataOverview', component: () => import('../views/front/DataOverview.vue')},
      { path: 'DataSampleMetadata', name: 'DataSampleMetadata', component: () => import('../views/front/DataSampleMetadata.vue')},
      { path: 'DataAssemblyQuality', name: 'DataAssemblyQuality', component: () => import('../views/front/DataAssemblyQuality.vue')},
      { path: 'DataTaxonomicAnnotation', name: 'DataTaxonomicAnnotation', component: () => import('../views/front/DataTaxonomicAnnotation.vue')},
      { path: 'FuncQualityAssessment', name: 'QualityAssessment', component: () => import('../views/front/FuncQualityAssessment.vue')},
      { path: 'FuncSpeciesAnnotation', name: 'SpeciesAnnotation', component: () => import('../views/front/FuncSpeciesAnnotation.vue')},
      { path: 'FuncStructuralAnnotation', name: 'StructuralAnnotation', component: () => import('../views/front/FuncStructuralAnnotation.vue')},
      { path: 'FuncFunctionalAnnotation', name: 'FunctionalAnnotation', component: () => import('../views/front/FuncFunctionalAnnotation.vue')},
      { path: 'FuncResourceSharing', name: 'ResourceSharing', component: () => import('../views/front/ResourceSharing.vue')},
      { path: 'UserManual', name: 'UserManual', component: () => import('../views/front/UserManual.vue')},
      { path: 'contact', name: 'Contact', component: () => import('../views/front/Contact.vue')},
      { path: 'species-directory', name: 'SpeciesDirectory', component: () => import('../views/front/SpeciesDirectory.vue')},
      { path: 'species/:speciesName', name: 'SpeciesDetail', component: () => import('../views/front/SpeciesDetail.vue'), props: true},
    ]
  },

  // 前台登录/注册 (已移除)
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  localStorage.setItem("currentPathName", to.name)
  store.commit("setPath")
  next()
})

export default router
